class LogoutContainer {
  constructor($location, $timeout, appErrorHandler, appSession) {
    'ngInject';

    this.$location = $location;
    this.$timeout = $timeout;
    this.appErrorHandler = appErrorHandler;
    this.appSession = appSession;
  }
  $onInit() {
    this.appSession.signout()
    .catch((error) => {
      this.appErrorHandler.handle(error, 'There was an error while signing out');
    })
    .then(() => {
      this.$timeout(() => {
        this.$location.path('/');
      });
    });
  }
}

export default {
  controller: LogoutContainer,
  template: `
    <div class="odsSmallIndicator -fullHeight"></div>
  `,
};
